<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useViewport } from '@/composables/useViewport';

// Initialize viewport handling for mobile browsers
// Sets up CSS custom properties (--vh, --vw) and resize listeners
useViewport();

// Debug logging to verify font usage
onMounted(() => {
  // Log font-family from document root elements
  const htmlElement = document.documentElement;
  const bodyElement = document.body;

  console.log('🎨 FONT DEBUG - App.vue mounted');
  console.log('📄 HTML font-family:', window.getComputedStyle(htmlElement).fontFamily);
  console.log('📄 Body font-family:', window.getComputedStyle(bodyElement).fontFamily);

  // Check if SK-Modernist is loaded
  const testElement = document.createElement('div');
  testElement.style.fontFamily = 'SK-Modernist';
  document.body.appendChild(testElement);

  const computedFont = window.getComputedStyle(testElement).fontFamily;
  console.log('🔤 SK-Modernist font-family:', computedFont);

  // Check if it actually resolves to SK-Modernist
  const isSKModernist = computedFont.includes('SK-Modernist') || computedFont.includes('SK Modernist');
  console.log('✅ SK-Modernist loaded:', isSKModernist);

  document.body.removeChild(testElement);

  // Log all loaded fonts
  if ('fonts' in document) {
    document.fonts.ready.then(() => {
      console.log('📚 Loaded fonts:');
      document.fonts.forEach(font => {
        console.log(`  - ${font.family} (${font.style})`);
      });
    });
  }
});
</script>

<style>
/* App-specific styles - Tailwind is imported in style.css */
</style>